export const deleteReportAccidentService = (fetch) => async (id) => {
  try {
    const response = await fetch({
      url: `/api/v1/siniestros-viales/reportes/${id}`,
      method: "delete",
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
